module.exports = __webpack_public_path__ + "img/episode8.4d053379.png";